import { Typography } from "@mui/material";

interface ColoredPercentageProps {
  percentage?: number | null;
}

const ColoredPercentage = ({ percentage }: ColoredPercentageProps) => {
  if (percentage === null || percentage === undefined) return "-";

  const getColor = () => {
    if (percentage <= 33) return "green.contrast";
    if (percentage > 33 && percentage <= 66) return "orange.contrast";
    return "red.contrast";
  };

  return <Typography sx={{ color: getColor() }}>{percentage}%</Typography>;
};

export default ColoredPercentage;
